export default {"src":"/_next/static/media/legcurl.28ad295f.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};